import { render, staticRenderFns } from "./orderServicerUnconfirmed.vue?vue&type=template&id=74d9130b&"
import script from "./orderServicerUnconfirmed.vue?vue&type=script&lang=ts&"
export * from "./orderServicerUnconfirmed.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports